/* Clocked Out: lets customers swipe the auto-scrolling rows (reviews, customer photos) on touch screens.
   The row keeps gliding by itself; a sideways swipe drags it, and when you let go it carries on from where you left it. */
(function () {
  function setup(el) {
    if (!el || el.dataset.coSwipe) return;
    el.dataset.coSwipe = '1';
    var vp = el.parentElement;
    vp.style.touchAction = 'pan-y';
    var active = false, lock = null, sx = 0, sy = 0, x0 = 0, x = 0, dur = 40, half = 1;
    function wrap(v) { while (v > 0) v -= half; while (v <= -half) v += half; return v; }
    vp.addEventListener('touchstart', function (e) {
      var cs = getComputedStyle(el);
      if (!cs.animationName || cs.animationName === 'none') return;
      var t = e.touches[0];
      active = true; lock = null; sx = t.clientX; sy = t.clientY;
      x0 = cs.transform && cs.transform !== 'none' ? new DOMMatrixReadOnly(cs.transform).m41 : 0;
      x = x0; dur = parseFloat(cs.animationDuration) || 40; half = el.offsetWidth / 2 || 1;
    }, { passive: true });
    vp.addEventListener('touchmove', function (e) {
      if (!active) return;
      var t = e.touches[0], mx = t.clientX - sx, my = t.clientY - sy;
      if (lock === null && (Math.abs(mx) > 6 || Math.abs(my) > 6)) {
        lock = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
        if (lock === 'x') { el.style.animationName = 'none'; el.style.transform = 'translateX(' + x0 + 'px)'; }
      }
      if (lock !== 'x') return;
      x = wrap(x0 + mx);
      el.style.transform = 'translateX(' + x + 'px)';
    }, { passive: true });
    function end() {
      if (!active) return;
      active = false;
      if (lock !== 'x') return;
      el.style.animationDelay = (-(-x / half) * dur).toFixed(3) + 's';
      el.style.transform = '';
      el.style.animationName = '';
    }
    vp.addEventListener('touchend', end);
    vp.addEventListener('touchcancel', end);
  }
  function init(scope) {
    (scope || document).querySelectorAll('.co-photos__track').forEach(setup);
    (scope || document).querySelectorAll('.co-grid--3').forEach(function (g) { if (g.querySelector(':scope > .co-rev-dup')) setup(g); });
  }
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();